<template>
  <div class="wrapper-freespins">
    <p class="title-freespins">{{ $t('free_spins_popups.free_spins') }}</p>
    <div class="main-content-popups-freeSpin-wrapper">
      <div class="main-content-popups-freeSpin-box">
        <p class="text-freespins">{{ $t('free_spins_popups.congratulations') }}</p>
        <p class="text-freespins">{{ $t('free_spins_popups.you_win', { amountSpins: spins }) }}</p>
        <p class="text-freespins">{{ $t('free_spins_popups.enjoy') }}</p>
        <p v-if="isNeedMoneyOnBalance" class="text-freespins text-freespins-under_text">
          {{ $t('free_spins_popups.min_bet_condition') }}
        </p>
      </div>
    </div>
    <ButtonPopup :closePopup="true" :text="btnCloseText" @closePopup="closePopup" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import ButtonPopup from '@/components/freeSpinsPopups/componentsPopup/ButtonPopup.vue';
import { ACTION } from '@/store/ACTION';

export default Vue.extend({
  name: 'StartFreeSpin',
  props: {
    closing: Boolean
  },
  components: {
    ButtonPopup
  },
  computed: {
    ...mapGetters([
      'getAmountLeftSpinsAchievement',
      'getAmountLeftSpinsTournament',
      'getAmountLeftSpinsFreeRounds',
      'isNeedMoneyOnBalance'
    ]),
    btnCloseText(): string {
      return <string>this.$i18n.t('free_spins_popups.ok') || '';
    },
    spins(): number {
      return (
        this.getAmountLeftSpinsFreeRounds || this.getAmountLeftSpinsAchievement || this.getAmountLeftSpinsTournament
      );
    }
  },
  methods: {
    closePopup(): void {
      promoApp.eventEmitter.emit(ACTION.HIDE_FREESPIN_WIN);
    }
  },
  watch: {
    closing: function () {
      this.closePopup();
    }
  }
});
</script>

<style scoped></style>
